export const unitMapping = {
  POUNDS: 'lbs',
  OUNCES: 'oz',
  KILOGRAMS: 'kg',
  GRAMS: 'g',
}
